import React from 'react';

const Preview: React.FC = () => (
  <div className="h-full bg-white flex flex-col items-center justify-center p-4">
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" className="mb-3">
      <rect width="56" height="56" rx="12" fill="#16a34a" />
      <text x="28" y="24" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold">X</text>
      <rect x="12" y="30" width="32" height="2" rx="1" fill="rgba(255,255,255,0.5)" />
      <rect x="12" y="35" width="32" height="2" rx="1" fill="rgba(255,255,255,0.5)" />
      <rect x="12" y="40" width="24" height="2" rx="1" fill="rgba(255,255,255,0.5)" />
    </svg>
    <div className="text-sm font-medium text-gray-700">Excel Spreadsheet</div>
    <div className="text-xs text-gray-400 mt-1 text-center max-w-48">
      Connect OneDrive files to display spreadsheet data
    </div>
  </div>
);

export default Preview;
